import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as bootstrap from 'bootstrap'
import mobile from "is-mobile";

export default class Homepage {
  constructor(dom) {
    this.dom = dom;

  }

  init() {
    
  }

  is_touch_enabled() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  initResponsiveHelper() {

  }

  resize() {
  }

  destory() {

  }
}
